<template>
  <div class="bigData" :class="{ fullscreen: $route.path.startsWith('/fullscreen') }">
    <div style="height: 30px; position: absolute; z-index: 10; left: 0; right: 0; transform: translateY(20px);" v-if="isRouteFullscreen">
      <div class="svgs" style="float: right;">
        <svg @click="$router.push('/fullscreen/list')" style="margin-right: -20px;" t="1751610347433" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1749" width="60" height="30"><path d="M598.361605 38.378364v198.288215H962.956065c38.378364 0 63.96394 25.585576 63.96394 63.963941v422.162006c0 38.378364-25.585576 63.96394-63.96394 63.96394H598.361605v198.288215c0 6.396394-6.396394 19.189182-12.792788 25.585576-12.792788 12.792788-38.378364 19.189182-51.171152 6.396394l-511.711523-454.143976-6.396394-6.396394c-25.585576-25.585576-19.189182-63.96394 6.396394-89.549517l511.711523-454.143976c12.792788-6.396394 19.189182-12.792788 25.585576-12.792788 25.585576 0 38.378364 19.189182 38.378364 38.378364z" p-id="1750"></path></svg>
        <svg @click="$router.push('/fullscreen/monitor')" t="1751608233199" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1468" width="60" height="30"><path d="M466.052637 0c6.384283 0 12.768565 6.384283 25.53713 12.768565l510.742616 453.284072c25.537131 25.537131 31.921413 63.842827 6.384283 89.379957l-6.384283 6.384283-510.742616 453.284071c-12.768565 12.768565-38.305696 12.768565-51.074261-6.384282-6.384283-6.384283-12.768565-19.152848-12.768565-25.537131v-197.912764H63.842827c-38.305696 0-63.842827-25.537131-63.842827-63.842827V300.061287c0-38.305696 25.537131-63.842827 63.842827-63.842827h363.904114V38.305696c0-19.152848 12.768565-38.305696 38.305696-38.305696z" p-id="1469"></path></svg>
      </div>
    </div>
    <div class="container" ref="container" v-loading="isLoading">
      <header>
        <div class="icon">
          Deman
        </div>
        <div class="title">
          {{ $t("overview.bigDataContent.title") }}
        </div>
      </header>
      <section class="content">
        <div class="left">
          <div class="top">
            <div class="device_status flex-col">
              <div class="title">{{ $t("warningForm.deviceStatus") }}</div>
              <div class="body">
                <div class="data">
                  <div class="img_wrapper">
                    <img :src="circlePng" alt="" />
                    <div class="count">
                      <div class="number">{{ statusData.running }}<small>{{ lang === "zh" ? "台" : "" }}</small></div>
                      <div class="status">{{ $t("station.running") }}</div>
                    </div>
                  </div>
                  <ul class="counts">
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.sleep") }}</span>
                      <span class="count">{{ statusData.sleep }}{{ lang === "zh" ? "台" : "" }}</span>
                    </li>
                    <li style="margin: 12px 0;">
                      <span class="description">{{ $t("overview.bigDataContent.prepare") }}</span>
                      <span class="count">{{ statusData.prepare }}{{ lang === "zh" ? "台" : "" }}</span>
                    </li>
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.powerOff") }}</span>
                      <span class="count" style="color: #649cc9;">{{ statusData.powerOff }}{{ lang === "zh" ? "台" : "" }}</span>
                    </li>
                  </ul>
                </div>
                <ul class="percent">
                  <li>
                    <span class="description">{{ $t("overview.bigDataContent.powerOnPercent") }}</span>
                    <span class="count">{{ statusData.powerOnPercent }}</span>
                  </li>
                  <li class="border"></li>
                  <li>
                    <span class="description">{{ $t("overview.bigDataContent.loadRate") }}</span>
                    <span class="count">{{ statusData.loadRate }}</span>
                  </li>
                  <li class="border"></li>
                  <li>
                    <span class="description">{{ $t("overview.bigDataContent.temp") }}</span>
                    <span class="count">{{ statusData.temperature }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="device_monitor">
              <section>
                <div class="body">
                  <div class="title">
                    <img :src="arrowPng" alt="" />
                    <div class="text">{{ $t("overview.bigDataContent.monitoringDevice") }}</div>
                    <img :src="arrowPng" alt="" style="transform: rotate(180deg);" />
                  </div>
                  <div class="counts">
                    <div class="count">
                      <span class="number">{{ monitorData.device }}</span>
                      <span class="description">{{ $t("overview.bigDataContent.device") }}</span>
                    </div>
                    <div class="count">
                      <span class="number">{{ monitorData.user }}</span>
                      <span class="description">{{ $t("overview.bigDataContent.user") }}</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div class="reduce">
              <section>
                <div class="body">
                  <div class="title">
                    <img :src="arrowPng" alt="" />
                    <div class="text">{{ $t("overview.bigDataContent.emissionReduction") }}</div>
                    <img :src="arrowPng" alt="" style="transform: rotate(180deg);" />
                  </div>
                  <div class="counts">
                    <div class="count">
                      <span class="number">{{ reduce.electricity }}</span>
                      <span class="description">{{ $t("overview.monitorContent.electricityConsumption") }}</span>
                      <small>(kW·H)</small>
                    </div>
                    <div class="count">
                      <span class="number">{{ reduce.co2 }}</span>
                      <span class="description" style="color: #7d99de;">{{ $t("overview.bigDataContent.CO2") }}</span>
                      <small style="color: #7d99de;">(t)</small>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div class="bottom">
            <div class="warning">
              <div class="title">
                {{ $t("overview.bigDataContent.warning") }}
                <a-icon class="settings_icon" v-if="!isFullScreen" type="setting" @click="warningSettingModalVisible = true" />
              </div>
              <section>
                <div class="headerNav">
                  <img :src="arrowPng" alt="" style="rotate: 180deg;" @click="scroll(-500)">
                  <div class="menus_wrapper" ref="menusWrapper">
                    <ul class="menus">
                      <li
                        v-for="(w, i) in selectedWarningMenus"
                        :key="w.id"
                        :class="{ active: i === activeWarningMenuIndex }"
                        @click="selectWarningMenu(i)"
                      >
                        {{ w[lang] }}
                      </li>
                    </ul>
                  </div>
                  <img :src="arrowPng" alt="" @click="scroll(500)">
                </div>
                <div class="list_wrapper">
                  <ul class="head">
                    <li
                      v-for="(c, i) in columns"
                      :key="c.key"
                      :style="{ width: c.width || 'auto', paddingRight: c.tooltip && i !== columns.length - 1 ? '1.5em' : '0' }"
                    >
                      <a-tooltip
                        v-if="c.tooltip"
                        :getPopupContainer="getPopupContainer"
                      >
                        <template slot="title">
                          {{ c[lang] }}
                        </template>
                        {{ c[lang] }}
                      </a-tooltip>
                      <span v-else>{{ c[lang] }}</span>
                    </li>
                  </ul>
                  <div class="warp" v-loading="isWarningLoading" @mouseenter="stopWarningListScroll" @mouseleave="startWarningListScroll" @wheel="handleWarpWheel">
                    <ul class="body" :style="`transform: translateY(-${translateY}px); transition: ${transition};`">
                      <li
                        v-for="w in warnings"
                        :key="w.id"
                      >
                        <span
                          v-for="col in columns"
                          :key="col.key"
                          :style="{ width: col.width }"
                          :title="w[col.key]"
                        >
                          {{ w[col.key] }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="reduce">
            <div class="title">
              {{ $t("overview.bigDataContent.year") }}
            </div>
            <section>
              <div class="top">
                <img :src="ePng" alt="">
                <section>
                  <div class="head">{{ $t("station.electricity") }}(kW·H)</div>
                  <ul class="data">
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.theYear") }}</span>
                      <span class="count">{{ reduce1.year_e }}</span>
                    </li>
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.month") }}</span>
                      <span class="count">{{ reduce1.month_e }}</span>
                    </li>
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.day") }}</span>
                      <span class="count">{{ reduce1.day_e }}</span>
                    </li>
                  </ul>
                </section>
              </div>
              <div class="bottom">
                <img :src="CO2Png" alt="">
                <section>
                  <div class="head">{{ $t("overview.bigDataContent.C") }}(t)</div>
                  <ul class="data">
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.theYear") }}</span>
                      <span class="count">{{ reduce1.year_c }}</span>
                    </li>
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.month") }}</span>
                      <span class="count">{{ reduce1.month_c }}</span>
                    </li>
                    <li>
                      <span class="description">{{ $t("overview.bigDataContent.day") }}</span>
                      <span class="count">{{ reduce1.day_c }}</span>
                    </li>
                  </ul>
                </section>
              </div>
            </section>
          </div>
          <div class="year">
            <div class="title">{{ $t("overview.bigDataContent.trend") }}</div>
            <div class="chart"></div>
          </div>
        </div>
      </section>
    </div>
    <a-modal
      v-model="warningSettingModalVisible"
      :title="`${$t('overview.list')}${$t('overview.listContent.setting')}`"
      :width="lang === 'en' ? 850 : 800"
      :afterClose="resetWarniSettingForm"
      @ok="confirmSetting"
    >
      <a-form-model
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        :style="`padding-right: ${ lang === 'en' ? '30px' : '10px' }`"
      >
        <a-form-model-item :label="`${$t('overview.listContent.replaceWord')}`">
          <a-input style="padding: 0 11px;" v-model="warningSettingForm.word" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.replaceRange')}`">
          <a-input-number v-model="warningSettingForm.min" style="width: 30%" /> ~
          <a-input-number v-model="warningSettingForm.max" style="width: 30%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.type')}`">
          <a-checkbox-group
            v-model="warningSettingForm.selectedWarnings"
            name="checkboxgroup"
          >
            <a-row :gutter="24">
              <a-col
                v-for="w in warningMenus"
                :span="lang === 'en' ? 12 : 8"
                :key="w.type"
              >
                <a-checkbox :value="w.type">
                  {{ w[lang] }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import circlePng from "@/assets/circle.png"
import arrowPng from "@/assets/arrow.png"
import ePng from "@/assets/e.png"
import CO2Png from "@/assets/co2.png"
import warningTypes from "./bigData"

import { getMenusOfCurrentUser } from "@/api/auth/menu"
import { getWarnData, getMonitorData } from "@/api/monitor"

export default {
  data() {
    return {
      isRouteFullscreen: false,
      circlePng,
      arrowPng,
      ePng,
      CO2Png,
      isFullScreen: false,
      warningSettingModalVisible: false,
      isLoading: false,
      /* 设备状态数据 */
      statusData: {
        running: 0,
        sleep: 0,
        prepare: 0,
        powerOff: 0,
        powerOnPercent: "0.00%",
        loadRate: "0.00%",
        temperature: "0℃"
      },
      /* 监测设备数据 */
      monitorData: {
        device: 0,
        user: 0
      },
      /* 累计减排效果数据 */
      reduce: {
        electricity: 0,
        co2: 0
      },
      /* 预警模块数据 */
      warningMenus: [],
      selectedWarningMenus: [],
      activeWarningMenuIndex: -1,
      columns: [],
      warnings: [],
      warningSettingForm: {
        word: "*",
        min: 3,
        max: 8,
        selectedWarnings: []
      },
      classOption: {
        singleHeight: 40,
        waitTime: 5000
      },
      translateY: 0,
      transition: "all 1s",
      isWarningLoading: false,
      /* 本年减排详情数据 */
      reduce1: {
        year_e: 0,
        month_e: 0,
        day_e: 0,
        year_c: "0.00",
        month_c: "0.00",
        day_c: "0.00"
      },
      /* 历年减排趋势数据 */
      xAxisData: [],
      data: [[], []]
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.drawChart()
    }
  },
  created() {
    this.pageSize = 8
    const warningSettingForm = localStorage.getItem("bigDataWarningSetingForm")
    if (warningSettingForm) {
      this.warningSettingForm = JSON.parse(warningSettingForm)
    }
    this.emptyWarningCount = 0
    this.round = 1
  },
  mounted() {
    const el = this.$refs.container, ratio = 1920 / 1080
    this.w = window.innerWidth - 245 < 1200 ? 1200 : window.innerWidth - 245
    this.h = Math.ceil(this.w / ratio)
    this.isRouteFullscreen = this.$route.path.startsWith("/fullscreen")
    let isFullScreen = document.fullscreenElement !== null
    isFullScreen = this.isRouteFullscreen || isFullScreen
    el.style.width = (isFullScreen ? screen.width : this.w) + "px"
    el.style.height = (isFullScreen ? Math.ceil(screen.width / ratio) : this.h) + "px"
    this.flexible()
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)

    this.render()
  },
  beforeDestroy() {
    this.stopWarningListScroll()
    clearTimeout(this.scrollGapTimer)
    clearTimeout(this.timerOfWarningMenuSelected)
    clearTimeout(this.fullscreenChangeGapTimer)
    this.scrollGapTimer = null
    this.timerOfWarningMenuSelected = null
    this.handleFullscreenChange = null
  },
  methods: {
    flexible () {
      const docEl = document.documentElement
      const dpr = window.devicePixelRatio || 1
      this.setBodyFontSize(dpr)
      this.setRemUnit(docEl)
    },
    setBodyFontSize (dpr) {
      if (document.body) {
        document.body.style.fontSize = (12 * dpr) + 'px'
      } else {
        document.addEventListener('DOMContentLoaded', () => { this.setBodyFontSize(dpr) })
      }
    },
    setRemUnit (docEl, isFullScreen) {
      let rem
      if (isFullScreen) {
        rem = docEl.clientWidth / 20
      } else {
        rem = (docEl.clientWidth < 1440 ? 1440 : docEl.clientWidth) / 20
      }
      docEl.style.fontSize = rem + 'px'
    },
    handleFullscreenChange () {
      this.stopWarningListScroll()
      clearTimeout(this.scrollGapTimer)
      this.scrollGapTimer = null
      const el = this.$refs.container
      const isFullScreen = document.fullscreenElement !== null
      if (isFullScreen) {
        el.style.width = window.innerWidth + 'px'
        el.style.height = window.innerWidth * 1080 / 1920 + 'px'
        this.setRemUnit(document.documentElement, true)
      } else {
        el.style.width = this.w + 'px'
        el.style.height = this.h + 'px'
        this.setRemUnit(document.documentElement)
      }
      this.isFullScreen = !!isFullScreen
      if (this.chart) {
        this.chart.resize()
      }
      this.fullscreenChangeGapTimer = setTimeout(this.startWarningListScroll, 1000)
    },
    async render() {
      this.isLoading = true
      await this.renderWarningMenus()
      await this.renderOtherData()
      if (this.selectedWarningMenus.length) {
        await this.selectWarningMenu(0)
      }
      this.isLoading = false
    },
    async renderWarningMenus() {
      const warningMenus = await this.requestWarningMenus()
      this.selectedWarningMenus = warningMenus
    },
    async renderWarningList() {
      this.isWarningLoading = true
      const data = await this.requestWarnings()
      this.warnings = data.map(w => {
        let replaceWord = this.warningSettingForm.word
        let start = this.warningSettingForm.min
        let end = this.warningSettingForm.max
        if (replaceWord && ((start || start === 0) || end)) {
          start = start || 1
          const c = w.company.split("")
          const e = end ? Math.min(end, c.length) : c.length
          for (let i = (start - 1); i < e; i++) {
            c[i] = replaceWord
          }
          w.company = c.join("")
        }
        if (w.percentage || w.percent === 0) {
          w.percentage = (w.percentage * 100).toFixed(0) + "%"
        }
        return w
      })
      
      this.isWarningLoading = false
    },
    async startWarningListScroll() {
      if (!this.warningScrollTimer) {
        this.transition = "all 1s"
        const body = document.querySelector(".warning .warp .body")
        const endTarget = body.scrollHeight - body.clientHeight
        this.warningScrollTimer = setInterval(() => {
          if (this.translateY >= endTarget) {
            this.transition = "all 0s"
            this.stopWarningListScroll()
            this.scrollGapTimer = setTimeout(() => {
              this.activeWarningMenuIndex++
              if (this.activeWarningMenuIndex >= this.selectedWarningMenus.length - 1) {
                this.activeWarningMenuIndex = 0
              }
              this.selectWarningMenu(this.activeWarningMenuIndex)
            }, 5000)
          } else {
            this.translateY += 40
          }
        }, 6000)
      }
    },
    stopWarningListScroll() {
      if (this.warningScrollTimer) {
        clearInterval(this.warningScrollTimer)
        this.warningScrollTimer = null
      }
    },
    async requestWarningMenus() {
      try {
        const { data } = await getMenusOfCurrentUser()
        const menu = data.find(r => r.id === 40)
        const totalRes = []
        let selectedRes = []

        let w
        for (let i = 0; i < warningTypes.length; i++) {
          w = warningTypes[i]
          if (menu.children.find(c => c.routeName === w.type)) {
            totalRes.push(w)
          }
        }

        if (this.warningSettingForm.selectedWarnings.length) {
          let s, r
          for (let i = 0; i < this.warningSettingForm.selectedWarnings.length; i++) {
            s = this.warningSettingForm.selectedWarnings[i]
            r = totalRes.find(res => res.type === s)
            if (r) {
              selectedRes.push(r)
            }
          }
        } else {
          selectedRes = [...totalRes]
        }

        this.warningMenus = totalRes

        return selectedRes
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async selectWarningMenu(i) {
      this.stopWarningListScroll()
      this.translateY = 0
      this.activeWarningMenuIndex = i
      const w = this.selectedWarningMenus[i]
      this.$nextTick(() => {
        const activeMenu = document.querySelector(".menus .active")
        if (activeMenu) {
          const wrapper = activeMenu.parentNode
          this.scroll(activeMenu.getBoundingClientRect().x - wrapper.clientWidth + 200)
        }
      })
      this.columns = w.columns
      await this.renderWarningList()
      if (this.emptyWarningCount === this.selectedWarningMenus.length) {
        this.$nextTick(this.startWarningListScroll)
      } else {
        if (this.warnings.length) {
          this.$nextTick(this.startWarningListScroll)
        } else {
          if (this.round === 1) {
            this.emptyWarningCount++
          }
          this.timerOfWarningMenuSelected = setTimeout(() => {
            this.selectWarningMenu((i + 1) === this.selectedWarningMenus.length ? 0 : (i + 1))
          }, 1000)
        }
      }
    },
    async requestWarnings() {
      try {
        const { data } = await getWarnData(this.selectedWarningMenus[this.activeWarningMenuIndex].id, -1)
        return data
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async renderOtherData() {
      const data = await this.requestData()
      data.runningStatus = data.runningStatus || []
      let r, total = 0
      for (let i = 0; i < data.runningStatus.length; i++) {
        r = data.runningStatus[i]
        if (r.key === "备机") {
          this.statusData.prepare = r.value || 0
        }
        if (r.key === "未上电") {
          this.statusData.powerOff = r.value || 0
        }
        if (r.key === "运行") {
          this.statusData.running = r.value || 0
        }
        if (r.key === "待机") {
          this.statusData.sleep = r.value || 0
        }
        total += r.value
      }
      if (total === 0) {
        this.statusData.powerOnPercent = "0.00%"
      } else {
        this.statusData.powerOnPercent = ((this.statusData.running + this.statusData.sleep) / total * 100).toFixed(2) + "%"
      }

      data.deviceAnalysis = data.deviceAnalysis || {}
      this.statusData.loadRate = (+(data.deviceAnalysis.avgLoadRate || 0) * 100).toFixed(2) + "%"
      this.statusData.temperature = (+(data.deviceAnalysis.avgTemperature || 0)).toFixed(2) + "℃"

      data.statistic = data.statistic || {}
      this.monitorData.device = data.statistic.deviceCnt || 0
      this.monitorData.user = data.statistic.customerCnt || 0

      data.emissionReduction = data.emissionReduction || {}
      this.reduce.electricity = data.emissionReduction.electricityConsumption || "0"
      this.reduce.co2 = data.emissionReduction.co2EmissionReduction || "0"
      data.emissionReduction.thisYear = data.emissionReduction.thisYear || []
      let t
      for (let i = 0; i < data.emissionReduction.thisYear.length; i++) {
        t = data.emissionReduction.thisYear[i]
        if (t.key === "year") {
          this.reduce1.year_e = t.elec
          this.reduce1.year_c = t.co2
        }
        if (t.key === "month") {
          this.reduce1.month_e = t.elec
          this.reduce1.month_c = t.co2
        }
        if (t.key === "day") {
          this.reduce1.day_e = t.elec
          this.reduce1.day_c = t.co2
        }
      }

      const xAxisData = [], chartData = [[], []]
      let e
      data.emissionReduction.erTrend = (data.emissionReduction.erTrend || []).slice(-6)
      for (let i = 0; i < data.emissionReduction.erTrend.length; i++) {
        e = data.emissionReduction.erTrend[i]
        xAxisData.push(e.key)
        chartData[0].push(e.elec)
        chartData[1].push(e.co2)
      }
      this.xAxisData = xAxisData
      this.data = chartData
      this.drawChart()
    },
    async requestData() {
      try {
        const { data } = await getMonitorData(0, 0)
        return data
      } catch(e) {
        console.log(e)
        return {}
      }
    },
    drawChart() {
      if (!this.chart) {
        this.chart = this.$echarts.init(document.querySelector(".chart"))
      }
      const nameMap = [
        {
          zh: "用电量(kW·H)",
          en: "Electricity(kW·H)"
        },
        {
          zh: "碳减排量(t)",
          en: "Carbon Reduction(t)"
        }
      ]
      const yAxisNameMap = [
        {
          zh: "用电量(亿)",
          en: "Electricity(100 million)"
        },
        {
          zh: "碳减排量(万)",
          en: "Carbon Reduction(10 thousand)"
        }
      ]
      const option = {
        grid: {
          top: "22%",
          left: "10%",
          right: "10%",
          bottom: "10%"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          show: true,
          top: "6%",
          textStyle: {
            color: "#92a4b5",
            fontSize: 16
          }
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLabel: {
            color: "#b9d0df"
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#b9d0df"
            },
            name: yAxisNameMap[0][this.lang],
            nameTextStyle: {
              color: "#87a2bb",
              padding: this.lang === "zh" ? [0, 0, 0, 10] : [0, 0, 0, 80],
              fontSize: 12
            }
          },
          {
            type: "value",
            axisLabel: {
              color: "#b9d0df"
            },
            splitLine: {
              show: false
            },
            name: yAxisNameMap[1][this.lang],
            nameTextStyle: {
              color: "#87a2bb",
              padding: this.lang === "zh" ? [0, 20, 0, 0] : [0, 135, 0, 0],
              fontSize: 12
            }
          }
        ],
        series: [
          {
            data: this.data[0],
            type: 'bar',
            yAxisIndex: 0,
            name: nameMap[0][this.lang],
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#51b3e1"
                },
                {
                  offset: 1,
                  color: "#285d91"
                }
              ]),
              borderRadius: 5
            },
            barWidth: "30%",
            barGap: "15%"
          },
          {
            data: this.data[1],
            type: 'bar',
            yAxisIndex: 1,
            name: nameMap[1][this.lang],
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#72e9c6"
                },
                {
                  offset: 1,
                  color: "#175c77"
                }
              ]),
              borderRadius: 5
            },
            barWidth: "30%",
            barGap: "15%"
          }
        ]
      }
      this.chart.setOption(option)
    },
    scroll(distance) {
      this.$refs.menusWrapper.scrollBy({
        left: distance,
        behavior: "smooth"
      })
    },
    confirmSetting() {
      localStorage.setItem("bigDataWarningSetingForm", JSON.stringify(this.warningSettingForm))
      this.warningSettingModalVisible = false
      let replaceWord = this.warningSettingForm.word
      let start = this.warningSettingForm.min
      let end = this.warningSettingForm.max
      this.warnings = this.warnings.map(w => {
        if (replaceWord && ((start || start === 0) || end)) {
          start = start || 1
          const c = w.company.split("")
          const e = end ? Math.min(end, c.length) : c.length
          for (let i = (start - 1); i < e; i++) {
            c[i] = replaceWord
          }
          w.company = c.join("")
        }
        return w
      })
      this.renderWarningList()
    },
    resetWarniSettingForm() {
      const warningSettingForm = localStorage.getItem("bigDataWarningSetingForm")
      if (warningSettingForm) {
        this.warningSettingForm = JSON.parse(warningSettingForm)
      } else {
        this.warningSettingForm = {
          word: "*",
          min: 3,
          max: 8,
          selectedWarnings: []
        }
      }
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    handleWarpWheel(e) {
      e.preventDefault()
      let translateY
      if (e.deltaY > 0) {
        translateY = Math.floor(e.deltaY / 40) * 40
        const body = document.querySelector(".warning .warp .body")
        const endTarget = body.scrollHeight - body.clientHeight
        if (+this.translateY + translateY < endTarget) {
          this.translateY += translateY
        }
      } else {
        translateY = Math.ceil(e.deltaY / 40) * 40
        if (+this.translateY + translateY >= 0) {
          this.translateY += translateY
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.fullscreen {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 0px;
    border-radius: 0px;
  }
  &::-webkit-scrollbar-track {
    width: 0px;
    border-radius: 0px;
  }
  &::-webkit-scrollbar-thumb {
    width: 0px;
    background-color: #4961a3;
    border-radius: 0px;
  }
}

.container {
  background: url(../../../assets/background.png) 0 0 /cover;
  overflow: auto;

  header {
    width: 100%;
    height: 12%;
    background: url(../../../assets/headTitleBg.png) 0 90% /contain no-repeat;
    padding: 0 20px;
    position: relative;

    .icon {
      font-size: .4375rem;
      color: #fff;
      text-shadow:
        0 0 30px rgba(202,228,225,0.34),
        0 0 34px rgba(30,132,242,0.78),
        0 0 54px rgba(30,132,242,0.92);
    }

    .title {
      position: absolute;
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
      text-shadow:
        0 0 30px rgba(202,228,225,0.34),
        0 0 34px rgba(30,132,242,0.78),
        0 0 54px rgba(30,132,242,0.92);
      font-size: .4583rem;
    }
  }

  .content {
    width: 100%;
    height: 88%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    .title {
      color: #c9e5f3;
      text-shadow:
        0 0 30px rgba(202,228,225,0.34),
        0 0 34px rgba(30,132,242,0.78),
        0 0 54px rgba(30,132,242,0.92);
      font-size: .2708rem;
      padding-left: 20px;
      display: flex;
      align-items: center;
    }

    .flex-col {
      display: flex;
      flex-direction: column;
    }

    .left {
      width: 75%;

      .top {
        height: 40%;
        display: flex;
        justify-content: space-between;

        .device_status {
          position: relative;
          width: 31.25%;
          background: url(../../../assets/background1.png) 0 0;
          background-size: 100% 100%;

          .title {
            height: 14.8%;
          }

          .body {
            flex: 1;

            .data {
              height: 70%;
              padding: 0 20px;
              display: flex;
              align-items: center;

              .img_wrapper {
                width: 50%;
                height: 100%;
                display: flex;
                align-items: center;
                position: relative;
                
                img {
                  width: 98%;
                  object-fit: cover;
                }

                .count {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  color: #fff;
                  transform: translate(-50%, -50%);
                  text-align: center;

                  .number {
                    font-size: .2917rem;
                    color: #4ab7cb;
                    font-weight: 600;

                    small {
                      font-size: .17rem;
                    }
                  }

                  .status {
                    color: #b3cae9;
                    font-size: .1875rem;
                    margin-top: -10px;
                  }
                }
              }

              .counts {
                width: 50%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding-left: 20px;

                li {
                  width: 100%;
                  background: linear-gradient(to right, #1f516c, #0f2d4f);
                  padding: 8px 20px;
                  display: flex;
                  justify-content: space-between;
                  font-size: .17rem;

                  .description {
                    color: #aecae2;
                  }

                  .count {
                    color: #c7b661;
                  }
                }
              }
            }

            .percent {
              height: 20%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 40px;
              
              li {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                font-size: .17rem;

                .description {
                  color: #aecae2;
                }

                .count {
                  color: #6bc0e5;
                }

                &.border {
                  height: 40%;
                  width: 2px;
                  background-color: #215876;
                }
              }
            }
          }
        }

        .device_monitor {
          width: 30.36%;
          background: url(../../../assets/background2.png) 0 0;
          background-size: 100% 100%;
          position: relative;

          section {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 13%;
            bottom: 0;
            left: 0;
            right: 0;

            .body {
              width: 100%;
              height: 100%;

              .title {
                width: 100%;
                height: 25%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 15px;
                text-shadow: unset;

                img {
                  height: 20%;
                  object-fit: cover;
                }
              }

              .counts {
                width: 100%;
                height: 40%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 50px;

                .count {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;

                  .number {
                    font-size: .3333rem;
                    color: #2d8cc3;
                    font-weight: 700;
                  }

                  .description {
                    font-size: .2083rem;
                    color: #b9d0df;
                  }
                }
              }
            }
          }
        }

        .reduce {
          width: 35%;
          background: url(../../../assets/background3.png) 0 0;
          background-size: 100% 100%;
          position: relative;

          section {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 13%;
            bottom: 0;
            left: 0;
            right: 0;

            .body {
              width: 100%;
              height: 100%;

              .title {
                width: 100%;
                height: 25%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 15px;
                text-shadow: unset;

                img {
                  height: 20%;
                  object-fit: cover;
                }
              }

              .counts {
                width: 100%;
                height: 40%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 20px;

                .count {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                  position: relative;

                  .number {
                    font-size: .3333rem;
                    color: #47e8e2;
                    font-weight: 700;
                  }

                  .description {
                    font-size: .2083rem;
                    color: #b9d0df;
                  }

                  small {
                    font-size: .2083rem;
                    color: #b9d0df;
                    position: absolute;
                    bottom: -30%;
                  }
                }
              }
            }
          }
        }
      }

      .bottom {
        height: calc(60% - 30px);
        margin-top: 15px;
        background: url(../../../assets/background5.png) 0 0;
        background-size: 100% 100%;

        .warning {
          height: 100%;

          .title {
            height: 9.78%;
            display: flex;
            position: relative;

            .settings_icon {
              color: #ddd;
              font-size: .3125rem;
              cursor: pointer;
              position: absolute;
              right: 30px;
              top: 23%;
              display: none;
            }

            &:hover {
              .settings_icon {
                display: block;
              }
            }
          }

          section {
            width: 100%;
            height: 90.22%;
            padding: 10px 20px;

            .headerNav {
              width: 100%;
              height: 10%;
              display: flex;
              justify-content: space-between;
              align-items: center;

              img {
                height: 50%;
                object-fit: cover;
                cursor: pointer;
              }

              .menus_wrapper {
                width: 83%;
                color: #b4d6f1;
                font-size: .2083rem;
                white-space: nowrap;
                overflow: hidden;

                .menus {
                  display: flex;
                  align-items: center;

                  li {
                    margin-right: 30px;
                    cursor: pointer;

                    &.active {
                      color: #67c1e1;
                    }
                  }
                }
              }
            }

            .list_wrapper {
              width: 100%;
              height: 90%;
              margin-top: 8px;

              .head {
                background-color: #1f4466;
                height: 50px;
                line-height: 50px;
                color: #b4d6f1;
                font-size: .2083rem;
                display: flex;
                padding: 0 20px;

                li {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }

              .warp {
                width: 100%;
                height: calc(100% - 70px);
                overflow: hidden;

                li {
                  width: 100%;
                  height: 40px;
                  line-height: 40px;
                  display: flex;
                  justify-content: space-around;
                  color: #a4bedf;
                  padding: 0 20px;
                  font-size: .1875rem;

                  &:nth-child(2n) {
                    background-color: #12436e;
                  }

                  span {
                    display: inline-block;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    padding-right: 1.5em;
                  }
                }
              }

              .body {
                height: 100%;
              }
            }
          }
        }
      }
    }

    .right {
      width: 24%;

      .reduce {
        height: 40%;
        background: url(../../../assets/background4.png) 0 0;
        background-size: 100% 100%;

        .title {
          height: 14.8%;
        }

        section {
          width: 100%;
          height: 85.2%;
          padding: 20px 5px;
          // padding-left: 0;
          
          .top, .bottom {
            width: 100%;
            height: 50%;
            display: flex;
            justify-content: space-between;

            img {
              height: 75%;
              object-fit: cover;
            }

            section {
              flex: 1;
              height: 100%;
              padding: 0 5px;

              .head {
                width: 100%;
                height: 23%;
                display: flex;
                align-items: center;
                background: linear-gradient(to right, #1f516c, #0f2d4f);
                color: #adc7e8;
                font-size: .2083rem;
              }

              .data {
                margin-top: 16px;
                display: flex;

                li {
                  display: flex;
                  flex-direction: column;
                  font-size: .1875rem;

                  &:first-child {
                    flex: 1.15;
                  }

                  &:nth-child(2) {
                    flex: 1.05;
                  }

                  &:last-child {
                    flex: .8;
                  }

                  .description {
                    color: #b9d0df;
                  }

                  .count {
                    color: #6bc0e5;
                  }
                }
              }
            }
          }

          .bottom {
            margin-top: 6%;
          }
        }
      }

      .year {
        height: calc(60% - 30px);
        margin-top: 15px;
        background: url(../../../assets/background6.png) 0 0;
        background-size: 100% 100%;

        .title {
          height: 9.78%;
        }

        .chart {
          width: 100%;
          height: 90.22%;
        }
      }
    }
  }
}

/deep/ .ant-form-item {
  margin-bottom: 15px;
}

/deep/ .el-loading-mask {
  background-color: rgba(0, 0, 0, .2);
}

/deep/ .ant-tooltip-inner {
  width: 110%;
}

.svgs {
  cursor: pointer;

  path {
    fill: transparent;
  }

  &:hover {
    
    path {
      fill: #fff;
    }
  }
}
</style>